import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { apiRequest } from '../lib/api';
import type { NoteRecord } from './useNotes';

async function fetchAppointmentNotes(
  clientId: string,
  appointmentId: string,
  accessToken: string | null | undefined,
) {
  return apiRequest<NoteRecord[]>(
    `/api/clients/${clientId}/notes?appointment_id=${appointmentId}`,
    { method: 'GET' },
    accessToken,
  );
}

export function useAppointmentNotes(clientId: string, appointmentId: string) {
  const { session } = useAuth();

  return useQuery<NoteRecord[]>({
    queryKey: ['notes', clientId, 'appointment', appointmentId],
    enabled: Boolean(clientId && appointmentId && session),
    queryFn: () => fetchAppointmentNotes(clientId, appointmentId, session?.access_token),
  });
}
